export default "__VITE_ASSET__KTqeP42C__"